import { defineStore, storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useLoginInfo } from "@erp/shared/composables/useLoginInfo";
import { INBOUND_STATUS, ORDER_APPROVAL_PHASE, TRANSFER_STATUS, } from "@erp/shared/types/order-approval-phase.types";
import { useIsOrderCommercialStore } from "./is-commercial.store";
import { useOrderConfirmAction } from "../../_composables/useOrderConfirmAction";
export const useOrderDetailDialogStore = defineStore("orderDetailDialog", () => {
    const isOpen = ref(false);
    const isCommercialStore = useIsOrderCommercialStore();
    const { isCommercial } = storeToRefs(isCommercialStore);
    const { readQuery: { data: currentOrder, isLoading, refetch }, totalPrice, setOrderId, updateMutation, orderConfirmCalcJson, } = useOrderConfirmAction(isCommercial);
    const { id } = useLoginInfo();
    const setOpen = {
        get: () => isOpen.value,
        set: (value) => (isOpen.value = value),
    };
    const isPurchaseManager = computed(() => {
        return Number(currentOrder.value?.creater) === id.value;
    });
    const isInProgress = computed(() => {
        return currentOrder.value?.approvalPhase === ORDER_APPROVAL_PHASE.진행중;
    });
    const isInboundComplete = computed(() => {
        return currentOrder.value?.inboundPhase === INBOUND_STATUS.입고완료;
    });
    const isTransferComplete = computed(() => {
        return currentOrder.value?.transferPhase === TRANSFER_STATUS.송금완료;
    });
    /**
     * @description 구매 완료 버튼 표시 조건
     * 구매 담당자이고 입고 완료와 송금 완료가 모두 완료된 상태
     */
    const showOrderCompleteBtn = computed(() => {
        return (isPurchaseManager.value &&
            isInboundComplete.value &&
            isTransferComplete.value);
    });
    /**
     * @description 입고 완료/송금 완료 버튼 표시 조건
     * 구매 담당자이고 입고 완료와 송금 완료가 모두 완료되지 않은 상태
     */
    const showInProgressBtn = computed(() => {
        return (isPurchaseManager.value &&
            isInProgress.value &&
            !(isInboundComplete.value && isTransferComplete.value));
    });
    /**
     * @description 발주 관련 파일 편집 불가 조건
     * 구매 담당자가 아니거나 송금 완료 상태라면 편집 불가
     */
    const editableOrderFile = computed(() => {
        return (isPurchaseManager.value &&
            isInProgress.value &&
            !isTransferComplete.value);
    });
    return {
        id,
        isOpen,
        setOpen,
        currentOrder,
        totalPrice,
        isLoading,
        refetch,
        setOrderId,
        updateMutation,
        orderConfirmCalcJson,
        isPurchaseManager,
        isInProgress,
        isInboundComplete,
        isTransferComplete,
        showInProgressBtn,
        showOrderCompleteBtn,
        editableOrderFile,
    };
});
